import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.dealer-franchisee.pages.AppResourceBase.';
  public static readonly readonly = `${Id.prefix}readonly`;
  public static readonly editingMode = `${Id.prefix}editingMode`;
  public static readonly readonlyCurrentlyInUseBy = `${Id.prefix}readonlyCurrentlyInUseBy`;
  public static readonly resourceLockEditing = `${Id.prefix}resourceLockEditing`;
  public static readonly resourceLockLocked = `${Id.prefix}resourceLockLocked`;
}

export class LangAppResourceBase {
  private constructor() {}
  public static readonly(): string {
    return interpolate(Id.readonly);
  }
  public static editingMode(): string {
    return interpolate(Id.editingMode);
  }
  public static readonlyCurrentlyInUseBy(): string {
    return interpolate(Id.readonlyCurrentlyInUseBy);
  }
  public static resourceLockEditing(): string {
    return interpolate(Id.resourceLockEditing);
  }
  public static resourceLockLocked(): string {
    return interpolate(Id.resourceLockLocked);
  }
}

export class AppResourceBaseModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.readonly, 'Readonly', 'Label for readonly mode');
    register.add(Id.editingMode, 'Editing Mode', 'Label for editing mode');
    register.add(
      Id.readonlyCurrentlyInUseBy,
      'Readonly - Currently in use by ',
      'Label for readonly mode with user. will be followed by a username link'
    );
    register.add(Id.resourceLockEditing, 'resource-lock-editing', 'CSS class for editing lock');
    register.add(Id.resourceLockLocked, 'resource-lock-locked', 'CSS class for locked resource');
  }
}
